// NOTE: Has to be imported like this otherwise Parcel will fail to produce a correct bundle
// See: https://github.com/parcel-bundler/parcel/issues/10175
import * as z from 'zod';

import { makeRoute } from './makeRoute';

export const Browse = makeRoute({
	path: '/',
	params: z.object({}),
});

export const Details = makeRoute({
	path: '/mcp/:id',
	params: z.object({
		id: z.string(),
	}),
});
